import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from '../Button';
import ArrowLeftIcon from './arrow-left.png';
import ArrowRightIcon from './arrow-right.png';
import './SimplePagination.css';

export class SimplePagination extends Component {
  state = {
    current: 1,
  };

  handlePreviousStep = () => {
    if (this.state.current <= 1) return;
    this.setState(
      ({ current }) => ({
        current: current - 1,
      }),
      () => {
        this.props.onChange(this.state.current);
      },
    );
  };

  handleNextStep = () => {
    if (this.state.current === this.props.total) return;
    this.setState(
      ({ current }) => ({
        current: current + 1,
      }),
      () => {
        this.props.onChange(this.state.current);
      },
    );
  };

  render() {
    return (
      <div className="simple-pagination">
        <Button
          className="simple-pagination__left-button"
          transparent
          onClick={this.handlePreviousStep}
        >
          <img
            className="simple-pagination__left-icon"
            alt="left icon"
            src={ArrowLeftIcon}
          />
        </Button>
        <div className="simple-pagination__step">
          {this.state.current} of {this.props.total}
        </div>
        <Button
          className="simple-pagination__right-button"
          transparent
          onClick={this.handleNextStep}
        >
          <img
            className="simple-pagination__right-icon"
            alt="right icon"
            src={ArrowRightIcon}
          />
        </Button>
      </div>
    );
  }
}

SimplePagination.propTypes = {
  total: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/SimplePagination/SimplePagination.js